import { render, staticRenderFns } from "./InvitationDetails.vue?vue&type=template&id=2082f9f1&scoped=true&"
import script from "./InvitationDetails.vue?vue&type=script&lang=js&"
export * from "./InvitationDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvitationDetails.vue?vue&type=style&index=0&id=2082f9f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082f9f1",
  null
  
)

export default component.exports